import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-603122ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card px-6" }
const _hoisted_2 = { class: "card-body pt-2 mt-2 d-flex justify-content-between align-items-start flex-column" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet h-40px me-3" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet h-40px me-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeaderTitle = _resolveComponent("HeaderTitle")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderTitle, {
      title: _ctx.$t('listMember.title'),
      subtitle: _ctx.subtitle
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: "#",
          class: "btn btn-sm btn-light"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("platformsInfo.ViewAll")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMembers, (member, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (member.firstName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_UserInfo, {
                  firstName: member.firstName,
                  lastName: member.lastName,
                  position: member.positionType
                }, null, 8, ["firstName", "lastName", "position"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_UserInfo, {
                  firstName: member.attributes['first-name'],
                  lastName: member.attributes['last-name'],
                  position: member.attributes['position-type']
                }, null, 8, ["firstName", "lastName", "position"])
              ]))
        ], 64))
      }), 128))
    ])
  ]))
}